import { Navigate } from 'react-router-dom'

export default function RedirectRestaurants() {
  return <Navigate to={'/opportunities/commercial/restaurants-bars/'} />
}
